// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
export type ScopeChangesTable_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, project:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  , materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, isPlanBasedSwap: boolean, addedLineItem: { __typename?: 'ChangeEventLineItem', id: string }, removalLineItem: { __typename?: 'ChangeEventLineItem', id: string } }>, lineItems: Array<{ __typename?: 'ChangeEventLineItem', quantity?: number | null | undefined, totalCostInCents: number, totalPriceInCents: number, id: string, name: string, proposedTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, originalTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, useQuantity: boolean, abbreviation: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string } } } | null | undefined }> };

export type ScopeChangesTable_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', quantity?: number | null | undefined, totalCostInCents: number, totalPriceInCents: number, id: string, name: string, proposedTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, originalTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, useQuantity: boolean, abbreviation: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string } } } | null | undefined };

export type ScopeChangesTable_LineItemTradeFragment = { __typename?: 'ChangeEventLineItem', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string } } } | null | undefined };

export const ScopeChangesTable_LineItemTradeFragmentDoc = gql`
    fragment ScopeChangesTable_LineItemTrade on ChangeEventLineItem {
  id
  tradePartner {
    id
    name
  }
  proposedBidContractLineItem {
    id
    ofIti
    revision {
      id
      version
      bidContract {
        id
        displayName
      }
    }
  }
}
    `;
export const ScopeChangesTable_ChangeEventLineItemFragmentDoc = gql`
    fragment ScopeChangesTable_ChangeEventLineItem on ChangeEventLineItem {
  ...Named
  quantity
  totalCostInCents
  totalPriceInCents
  proposedTask {
    ...Named
  }
  originalTask {
    ...Named
  }
  typeDetail {
    code
    name
  }
  item {
    ...DisplayNamed
    costCode {
      ...DisplayNamed
    }
  }
  unitOfMeasure {
    id
    useQuantity
    abbreviation
  }
  ...ScopeChangesTable_LineItemTrade
}
    ${NamedFragmentDoc}
${DisplayNamedFragmentDoc}
${ScopeChangesTable_LineItemTradeFragmentDoc}`;
export const ScopeChangesTable_ChangeEventFragmentDoc = gql`
    fragment ScopeChangesTable_ChangeEvent on ChangeEvent {
  id
  project {
    id
  }
  materialVariantSwaps {
    id
    isPlanBasedSwap
    addedLineItem {
      id
    }
    removalLineItem {
      id
    }
  }
  lineItems {
    ...ScopeChangesTable_ChangeEventLineItem
  }
}
    ${ScopeChangesTable_ChangeEventLineItemFragmentDoc}`;